import $ from 'jquery'

$(document).on('facetwp-loaded', function() {
  $('.facetwp-input-wrap').each(function() {
    if ($(this).find('.facetwp-search-submit').length < 1) {
      $(this).find('.facetwp-search').after('<div class="facetwp-search-submit link--dot" onclick="FWP.refresh()">Search<span class="link__switch relative"></span></div>');
    }
  })
})


$(document).on('facetwp-refresh', function () {
  console.log('facetwp-refresh');

  if (FWP.loaded && null !== FWP.active_facet) {
    let facet = FWP.active_facet;
    let facet_type = facet.attr('data-type');
    if ('pager' == facet_type) {
      FWP.setHash();
      window.location.reload();

      if ($('.section__insights').length > 0) {
        //$('html, body').animate({ scrollTop: $('.section__insights').offset().top - 180 }, 0)
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/js/facet.js